import { editTaskError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getEditTaskError({ uuid }) {
      const req = getState().find(({ task }) => task.uuid === uuid);

      return req ? req.error : editTaskError;
    },
    isEditTaskRequestPending({ uuid }) {
      const req = getState().find(({ task }) => task.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditTaskRequestSuccess({ uuid }) {
      const req = getState().find(({ task }) => task.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    isEditTaskRequestFailure({ uuid }) {
      const req = getState().find(({ task }) => task.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
  };
}

export { createSelector };
